import FormCrudCRUDContext from "context/FormCrudContex";
import React, { useContext } from "react";

export const PDFUserToUserSalida = ({ values }) => {
  const { opcional, nit_qualified2 } = useContext(FormCrudCRUDContext);

  const { commercial_invoice, value_duta } = values;
  return (
    <div className="row">
      <div className="col">
        <p>
          <strong>Nit: </strong>
          {nit_qualified2}
        </p>
        <p>
          <strong>Factura Comercial: </strong> {commercial_invoice}
        </p>
      </div>

      <div className="col">
        {opcional && (
          <p>
            <strong>{opcional}: </strong> {value_duta}
          </p>
        )}
      </div>
    </div>
  );
};
